import { render, staticRenderFns } from "./Billet.vue?vue&type=template&id=187ed40e&scoped=true&"
import script from "./Billet.vue?vue&type=script&lang=js&"
export * from "./Billet.vue?vue&type=script&lang=js&"
import style0 from "./Billet.vue?vue&type=style&index=0&id=187ed40e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187ed40e",
  null
  
)

export default component.exports